import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React, { type FC, type ReactNode } from 'react'

type Props = {
  name: string
  asset: Queries.CardComparatorAssetFragment
  underCondition: ReactNode
  link: string
}

const CardImage: FC<Props> = ({ asset }) => (
  <div className="px-4 tablet:px-5 laptop:px-10">
    <GatsbyImage
      alt={asset.description}
      className="flex w-full overflow-hidden rounded-[0.625rem]"
      image={getImage(asset)}
    />
  </div>
)
export default CardImage
